import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useSpring, animated } from 'react-spring';
import SearchBarContext, { useLockFocus } from './context';

const Button = styled(animated.button)`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  height: 38px;
  ${props => (props.pseudomobile === 'true' ? `
    width: 40px;
    position: relative;
    top: 3px;
    border-width: 0;
  ` : `
    border-width: 1px;
    border-style: solid;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    width: 118px;
  `)};
`;

const Icon = styled.span`
  font-weight: 900;
  position: relative;
  top: 1px;
  color: ${props => ((props.theme.isMobile || props.expanded) ? '#fff' : props.theme.secondaryColor)};
`;

const toRGBA = (rgbString, alpha) => rgbString.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);

export default function SearchLivewireButton() {
  const {
    state: {
      expanded, value, pseudoMobile,
    },
    dispatch,
  } = React.useContext(SearchBarContext);
  // These are in "rgb(x, y, z)" format.
  const {
    primaryColor, secondaryColor,
  } = React.useContext(ThemeContext);

  const {
    alpha, radius, borderBottomColor, color,
  } = useSpring({
    alpha: expanded ? toRGBA(primaryColor, 1) : toRGBA(primaryColor, 0),
    radius: expanded ? 4 : 0,
    borderBottomColor: expanded ? primaryColor : secondaryColor,
    color: expanded ? '#ffffff' : secondaryColor,
  });

  const onClicked = e => {
    e && e.preventDefault();
    if (!expanded) {
      dispatch({ type: 'expand', payload: true });
    } else if (value.length) {
      dispatch({ type: 'search' });
    }
  };

  return (
    <Button
      type="button"
      {...useLockFocus()}
      onClick={onClicked}
      pseudomobile={pseudoMobile.toString()}
      style={{
        backgroundColor: alpha,
        borderTopRightRadius: radius.interpolate(v => `${v}px`),
        borderBottomRightRadius: radius.interpolate(v => `${v}px`),
        ...(pseudoMobile ? {} : {
          borderBottomColor,
          color,
          borderTopColor: alpha,
          borderLeftColor: alpha,
          borderRightColor: alpha,
        }),
      }}
    >
      {
        pseudoMobile
          ? <Icon className="icon-lw icon-lw-magnifying-glass" {...{ expanded }} />
          : 'Search Livewire'
      }
    </Button>
  );
}
